export default __webpack_public_path__ + "static/media/arrowIcon.286728ca.svg";